module.exports = __webpack_public_path__ + "index.js?bdd13cc4d60010517831fc71a50ef64e";